const isCourtLivestreamEnabled = (courts, courtId) => {
  if (!courtId || !courts?.length) return false

  const selectedCourt = courts.find((c) => c.id === courtId)
  return selectedCourt?.livestreamEnabled
}

export default isCourtLivestreamEnabled
